import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'

import axios from 'axios'

let firebaseApp

const getFirebaseConfig = () => window.pageConfig?.firebaseConfig

const ensureFirebaseApp = () => {
  const config = getFirebaseConfig()

  if (!config?.apiKey) {
    console.warn('Firebase config missing. Skipping messaging setup.')
    return null
  }

  if (!firebaseApp) {
    firebaseApp = initializeApp(config)

    try {
      getAnalytics(firebaseApp)
    } catch (error) {
      console.warn('Firebase analytics initialization failed', error)
    }
  }

  return firebaseApp
}

export const messaging = async () => {
  const appInstance = ensureFirebaseApp()
  if (!appInstance) {
    return null
  }

  try {
    const isSupportedBrowser = await isSupported()
    if (isSupportedBrowser) {
      console.log('Firebase supported this browser')
      return getMessaging(appInstance)
    }

    window.firebaseNotificationsDisabled = true
    console.log('Firebase not supported this browser')
    return false
  } catch (err) {
    console.log(err)
    return null
  }
}

export const requestPushNotificationPermission = async () => {
  const messagingResolve = await messaging()

  if (!messagingResolve) {
    console.warn('Firebase messaging unavailable; aborting push registration')
    return
  }

  const vapidKey = window.pageConfig?.firebaseVapidKey
  if (!vapidKey) {
    console.warn('Firebase VAPID key missing. Skipping push registration.')
    return
  }

  if (typeof Notification === 'undefined') {
    console.log('Notification not supported')
    return
  }

  const swPath = '/service-worker.js'
  const swScope = { scope: '/' }

  navigator.serviceWorker.register(swPath, swScope).then((registration) => {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        const options = {
          vapidKey,
          serviceWorkerRegistration: registration,
        }

        getToken(messagingResolve, options)
          .then((currentToken) => {
            if (currentToken) {
              const metaToken = document.getElementsByName('csrf-token')[0]
              let token = null

              if (metaToken) {
                token = metaToken.getAttribute('content')
                axios.defaults.headers.common['X-CSRF-Token'] = token
              }

              axios
                .post('/api/internal/iterable/register_push_notification', {
                  token: currentToken,
                })
                .then(() => {})
            }
          })
          .catch((err) => {
            console.log('An error occurred while retrieving token. ', err)
          })
      }
    })
  })
}
